export const ANUAL = '1'
export const MENSUAL = '2'

export const __dictionary = {
  [ANUAL]: {
    id: ANUAL,
    nombre: 'ANUAL'
  },
  [MENSUAL]: {
    id: MENSUAL,
    nombre: 'MENSUAL'
  }
}

export const __array = [__dictionary[ANUAL], __dictionary[MENSUAL]]

